function getRankModifiersForUnit(agentUnit, numberOfAdjacentFriends, rankedPosition, gameState, rules, hexProperties) {
    let rank = 0;
    const neighbours = rules.getExistingNeighbours(rankedPosition);
    let numOfNotBoldFriends = 0;
    let numOfFriends = 0;
    neighbours.forEach((neighbour) => {
        const unitOnPosition = rules.getUnitOnPosition(neighbour, gameState.units);
        if (!unitOnPosition) {
            return;
        }
        if (unitOnPosition.id === agentUnit.id) {
            return;
        }
        if (unitOnPosition.side === agentUnit.side) {
            numOfFriends += 1;
            if (!rules.isUnitBold(unitOnPosition, gameState)) {
                numOfNotBoldFriends += 1;
            }
        }
    });
    if (hexProperties.getDistance(agentUnit.position, rankedPosition) === 1 &&
        numOfFriends <= numberOfAdjacentFriends) {
        rank = -rankedPosition.rank;
    }
    else {
        rank += numOfNotBoldFriends;
    }
    return rank;
}
export default getRankModifiersForUnit;
